import React from 'react';
import InvoiceEvaluatorComponent from './InvoiceEvaluatorComponent';
import ThirdPartyJobPaymentForExportPaymentAdmin from './ThirdPartyJobPaymentForExportPaymentAdmin';
import TabbedPage from '../../../../Elements/TabbedPage';

export default class EvaluatorPaymentTabbed extends React.Component {
  static defaultProps = {
    exportPaymentId: 0,
  };

  componentDidMount() {}

  tabs = [
    {
      label: 'Evaluator Payments',
      id: 'evaluatorpayments',
      icon: 'fa-solid fa-credit-card',
      component: <InvoiceEvaluatorComponent exportPaymentId={this.props.exportPaymentId} />,
    },
    {
      label: 'Third-Party Evaluator Payments',
      id: 'thirdpartyjobpayments',
      icon: 'fa-solid fa-credit-card',
      component: <ThirdPartyJobPaymentForExportPaymentAdmin exportPaymentId={this.props.exportPaymentId} />,
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <div className='bg-white p-1'>
          <div className='TabbedPage'>
            <TabbedPage tabs={this.tabs} />
          </div>
        </div>
      </div>
    );
  }
}
